import { render, staticRenderFns } from "./EditBanking.vue?vue&type=template&id=0023e1bf&scoped=true"
import script from "./EditBanking.vue?vue&type=script&lang=js"
export * from "./EditBanking.vue?vue&type=script&lang=js"
import style0 from "./EditBanking.vue?vue&type=style&index=0&id=0023e1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023e1bf",
  null
  
)

export default component.exports